export { mergeHotStreamHandlerArray } from './merge-hot-stream-array/merge-hot-stream-handler-array';
